
function mergeSort(array, speed){

}

export default mergeSort